import type { Fields } from '../../types';
import { FieldTypes } from '../../types/fieldTypes';
import { frequency as options } from './options';

// farmaci
export const step5: Fields = [
  {
    code: 1101,
    name: 'Antistaminici',
    description: 'Difenidramina, Fexofenadina, Levocetirizina, Triprolidina',
    type: FieldTypes.radio,
    options,
    group: 1100,
  },
  {
    code: 1102,
    name: 'FANS',
    description: 'Celecoxib, Diclofenac, Ibuprofene, Ketoprofen, Naproxen',
    type: FieldTypes.radio,
    options,
    group: 1100,
  },
  {
    code: 1103,
    name: 'Aspirina',
    description: '',
    type: FieldTypes.radio,
    options,
    group: 1100,
  },
  {
    code: 1104,
    name: 'Paracetamolo',
    description: '',
    type: FieldTypes.radio,
    options,
    group: 1100,
  },
  {
    code: 1105,
    name: 'Analgesici narcotici',
    description: 'Buprenorfina, Codeina, Diidrocodeina, Fentanyl, Idrocodone, Idromorfone, Metadone, Morfina',
    type: FieldTypes.radio,
    options,
    group: 1100,
  },
  {
    code: 1106,
    name: 'Broncodilatatori',
    description: 'Salbutamolo, Teofillina',
    type: FieldTypes.radio,
    options,
    group: 1100,
  },
  {
    code: 1107,
    name: 'ACE inibitori',
    description: 'Captopril, Enalapril, Lisinopril, Moexipril, Quinapril, Ramipril',
    type: FieldTypes.radio,
    options,
    group: 1100,
  },
  {
    code: 1108,
    name: 'Beta-bloccanti',
    description: 'Carvedilolo, Metoprololo',
    type: FieldTypes.radio,
    options,
    group: 1100,
  },
  {
    code: 1109,
    name: 'Diuretici',
    description: 'Triamterene (da solo)',
    type: FieldTypes.radio,
    options,
    group: 1100,
  },
  {
    code: 1110,
    name: 'Digossina',
    description: '',
    type: FieldTypes.radio,
    options,
    group: 1100,
  },
  {
    code: 1111,
    name: 'Antidiabetici',
    description: 'Metformina',
    type: FieldTypes.radio,
    options,
    group: 1100,
  },
  {
    code: 1112,
    name: 'Statine',
    description: 'Atorvastatina, Lovastatina, Simvastatina',
    type: FieldTypes.radio,
    options,
    group: 1100,
  },
  {
    code: 1113,
    name: 'Nitrati vasodilatatori',
    description: 'Isosorbide dinitrato, Nitroglicerina mononitrato',
    type: FieldTypes.radio,
    options,
    group: 1100,
  },
  {
    code: 1114,
    name: 'Anticoagulanti antagonisti vit.K: Warfarin',
    description: '',
    type: FieldTypes.radio,
    options,
    group: 1100,
  },
  {
    code: 1115,
    name: 'Inibitori pompe protoniche',
    description: 'Rabeprazolo, Dexlansoprazolo, Esomeprazolo, Lansoprazolo, Omeprazolo, Pantoprazolo',
    type: FieldTypes.radio,
    options,
    group: 1100,
  },
  {
    code: 1116,
    name: 'Farmaci tiroidei',
    description: 'Levotiroxina',
    type: FieldTypes.radio,
    options,
    group: 1100,
  },
  {
    code: 1117,
    name: 'Ciprofloxacina',
    description: '',
    type: FieldTypes.radio,
    options,
    group: 1100,
  },
  {
    code: 1118,
    name: 'Tetraciclina',
    description: '',
    type: FieldTypes.radio,
    options,
    group: 1100,
  },
  {
    code: 1119,
    name: 'Linezolid',
    description: '',
    type: FieldTypes.radio,
    options,
    group: 1100,
  },
  {
    code: 1120,
    name: 'Antimicobatterici',
    description: 'Etambutolo, Isoniazide, Rifampicina',
    type: FieldTypes.radio,
    options,
    group: 1100,
  },
  {
    code: 1121,
    name: 'Antidepressivi - Inibitori della monoaminoossidasi (MAO)',
    description: 'Fenelzina, Tranilcipromina',
    type: FieldTypes.radio,
    options,
    group: 1100,
  },
  {
    code: 1122,
    name: 'Antidepressivi',
    description: 'Citalopram, Escitalopram, Fluoxetina, Paroxetina, Sertralina',
    type: FieldTypes.radio,
    options,
    group: 1100,
  },
  {
    code: 1123,
    name: 'Farmaci anti-ansia e panico',
    description: 'Alprazolam, Clonazepam, Diazepam, Lorazepam',
    type: FieldTypes.radio,
    options,
    group: 1100,
  },
  {
    code: 1124,
    name: 'Antiepilettico',
    description: 'Lamotrigina',
    type: FieldTypes.radio,
    options,
    group: 1100,
  },
  {
    code: 1125,
    name: 'Farmaci per anestesia',
    description: 'Sevoflurano',
    type: FieldTypes.radio,
    options,
    group: 1100,
  },
  {
    code: 1126,
    name: 'Immunosoppressori',
    description: 'Ciclosporina, Tacrolimus',
    type: FieldTypes.radio,
    options,
    group: 1100,
  },
];
